import * as SettingOAuth from './../actions/settingOAuthAction';

const initState = {
    channel_id: undefined,
    verifying: false,
    verify_failure_visible: false,
    verify_success_visible: false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case SettingOAuth.ON_LOAD_CHANNEL:
            return { ...state, verify_success: false, channel_id: action.payload }
        case SettingOAuth.ON_VERIFY_OAUTH:
            return { ...state, verifying: true }
        case SettingOAuth.ON_VERIFY_OAUTH_SUCCESS: {
            return { ...state, verify_success_visible: true, verify_success: true }
        }
        case SettingOAuth.ON_VERIFY_OAUTH_FAILURE: {
            return { ...state, verify_failure_visible: true }
        }
        case SettingOAuth.ON_OK_OAUTH: {
            return {
                ...state,
                verifying: false,
                verify_failure_visible: false,
                verify_success_visible: false,
            }
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/settingOAuthReducer.js